import { Observable, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SiToastNotificationService } from '@siemens/element-ng/toast-notification';
import { AppError } from './app.error';

@Injectable({
    providedIn: 'root'
})
export class ErrorService {
    private readonly toastService = inject(SiToastNotificationService);

    public handleError<T>(operation?: string): (error: Error) => Observable<T> {
        return (error: Error): Observable<T> => {
            this.toastService.showToastNotification({
                title: `Error: ${operation}`,
                message: `${error?.name}`,
                state: 'danger',
                timeout: 50000
            });
            return throwError(() => new AppError(this.backendMessage(error) ?? error?.message));
        };
    }

    /** NestJS error bodies carry the reason in `message` (a string or a list of validation messages). */
    private backendMessage(error: Error): string | undefined {
        const message = error instanceof HttpErrorResponse ? error.error?.message : undefined;
        if (Array.isArray(message)) {
            return message.join(', ');
        }
        return typeof message === 'string' ? message : undefined;
    }
}
